// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'A carregar a alteração…',
  load_failed: 'Não foi possível carregar esta alteração.',
  load_retry: 'Tentar novamente',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Isto já tinha sido aprovado, por isso não havia mais nada a fazer.',
  action_failed: 'Não foi possível concluir a ação, por isso nada foi alterado. Tente novamente dentro de instantes.',
  removed: 'Removido',
  retry: 'Tentar novamente',
  retry_one: 'Tentar {{name}} novamente',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Aprovada.',
    retried: 'Nova tentativa feita.',
    rejected: 'Rejeitada.',
  },
  done: {
    summary_one: 'Concluído. {{count}} alteração aplicada.',
    summary_other: 'Concluído. {{count}} alterações aplicadas.',
    skipped_one: '{{count}} ignorada, nada foi alterado.',
    skipped_other: '{{count}} ignoradas, nada foi alterado.',
  },
  partial: {
    summary_one: '{{applied}} de {{approved}} alterações aplicadas. {{count}} não foram aplicadas.',
    summary_other: '{{applied}} de {{approved}} alterações aplicadas. {{count}} não foram aplicadas.',
    detail_one: 'As {{applied}} foram guardadas. Nada foi alterado nas {{count}} abaixo.',
    detail_other: 'As {{applied}} foram guardadas. Nada foi alterado nas {{count}} abaixo.',
  },
  stale: {
    summary: '{{applied}} de {{approved}} alterações aplicadas.',
    detail_one: '{{count}} foi alterada entretanto por outra pessoa.',
    detail_other: '{{count}} foram alteradas entretanto por outra pessoa.',
    reason:
      '{{name}} alterou para {{value}} às {{time}}, antes de aprovar, por isso deixei como está. Aqui está novamente, a partir do novo valor:',
  },
  undone: {
    summary_one: 'Anulado. A {{count}} alteração voltou ao estado anterior.',
    summary_other: 'Anulado. As {{count}} alterações voltaram ao estado anterior.',
    detail: 'A anulação também fica registada no registo do Amigo e em Menu → Histórico de edições.',
  },
  summary: {
    average: '{{amount}} por prato em média',
    needs_look: 'Requer atenção',
    nothing_else: 'Nada mais é alterado',
  },
  labels: {
    waiting: 'A aguardar aprovação',
    skip: 'Ignorar',
    unskip: 'Anular ignorar',
    approve_all: 'Aprovar tudo',
    approve_one: 'Aprovar {{count}}',
    approve_other: 'Aprovar {{count}}',
    approve_row: 'Aprovar',
    reject: 'Rejeitar…',
    reject_confirm: 'Rejeitar',
    back: 'Voltar',
    why: {
      amigo: 'Porquê? (opcional, o Amigo lê isto)',
      assistant: 'Porquê? (opcional, o assistente lê isto)',
    },
    hint: 'Ou responda abaixo para alterar algo.',
    show_all_one: 'Mostrar todas as {{count}} alterações',
    show_all_other: 'Mostrar todas as {{count}} alterações',
    show_less: 'Mostrar menos',
    applying_one: 'A aplicar {{count}} alteração…',
    applying_other: 'A aplicar {{count}} alterações…',
    rows: {
      skipped: 'Ignorada',
      applied: 'Aplicada',
      failed: 'Não aplicada',
      changed: 'Alterada entretanto',
      kept: 'Deixada como está',
    },
    history: {
      amigo: 'Abrir no registo do Amigo',
      assistant: 'Abrir no registo do assistente',
    },
    undo: 'Anular',
    to: 'para',
    from: 'de',
    rejected: 'Rejeitada',
    replaced: 'Substituída',
    expired: 'Expirada',
  },
};
